import { BLAST_ERROR_LABELS, htmlTemplateErrorLabel } from '../../constants';
export const extractBlastErrorMessage = (error) => {
    const data = error.response?.data;
    if (data?.errors) {
        const codes = Array.isArray(data.errors) ? data.errors : [data.errors];
        const labels = codes
            .filter((c) => typeof c === 'string')
            .map((c) => BLAST_ERROR_LABELS[c] ?? htmlTemplateErrorLabel(c));
        if (labels.length)
            return labels.join('. ');
    }
    if (data?.error && typeof data.error === 'string') {
        return BLAST_ERROR_LABELS[data.error] ?? htmlTemplateErrorLabel(data.error);
    }
    if (data?.detail && typeof data.detail === 'string') {
        return data.detail;
    }
    return error.message || 'Request failed';
};
export const extractBlastErrorCode = (error) => {
    if (error == null || typeof error !== 'object')
        return null;
    const resp = error.response;
    if (resp == null || typeof resp !== 'object')
        return null;
    const data = resp.data;
    if (data == null || typeof data !== 'object')
        return null;
    const d = data;
    if (typeof d.code === 'string')
        return d.code;
    if (typeof d.error === 'string')
        return d.error;
    if (typeof d.errors === 'string')
        return d.errors;
    if (Array.isArray(d.errors) && typeof d.errors[0] === 'string')
        return d.errors[0];
    if (typeof d.detail === 'string')
        return d.detail;
    return null;
};
export const toDatetimeLocal = (iso) => {
    if (!iso)
        return '';
    return iso
        .replace(/Z$/, '')
        .replace(/\.\d+$/, '')
        .slice(0, 16);
};
export const toUtcIso = (datetimeLocal) => {
    if (!datetimeLocal)
        return '';
    return datetimeLocal + ':00Z';
};
export const getScheduleMinimum = () => new Date((Math.floor(Date.now() / 60000) + 1) * 60000).toISOString().slice(0, 16);
export const getScheduleError = (value) => {
    if (!value)
        return 'Scheduled time is required.';
    if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}$/.test(value))
        return 'Enter a valid scheduled date and time.';
    const time = new Date(toUtcIso(value));
    if (!Number.isFinite(time.getTime()) || time.toISOString().slice(0, 16) !== value)
        return 'Enter a valid scheduled date and time.';
    return time.getTime() <= Date.now() ? 'Scheduled time must be in the future.' : null;
};
export const getLocalSendTimeError = (value) => value && !/^([01]\d|2[0-3]):[0-5]\d$/.test(value)
    ? 'Enter a local send time in HH:MM format (00:00–23:59).'
    : null;
